<template>
  <div>

    <!-- Risk dashboard -->
    <div class="card mb-3"
         id="dashboard"
         v-if="!showOnTask"
    >
      <div class="card-body">
        <div class="row mt-2" v-if="dataTypes && dataTypes.length">
          <div class="col-md-2 pr-0">{{ $t('system.data_types') }}:</div>
          <div class="col-md-10 pl-0">
            <span v-for="item in dataTypes">
              <span class="mr-3">
                <font-awesome-icon
                    icon="exclamation-triangle"
                    class="risk-6"
                />
                {{ $t('classification.' + $options.filters.slugify(item)) }}
              </span>
            </span>
          </div>
        </div>
        <div class="row mt-2" v-if="processingTypes.profiling === 1 || processingTypes.direct_marketing === 1 || processingTypes.automated_decision === 1 || processingTypes.children === 1 || processingTypes.monitoring === 1">
          <div class="col-md-2 pr-0">{{ $t('system.processing_types') }}:</div>
          <div class="col-md-10 pl-0">
            <span v-if="processingTypes.profiling === 1"  class="mr-3">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-6"
              />
              {{ $t('activities.processing_type.profiling') }}
             </span>
            <span v-if="processingTypes.direct_marketing === 1"  class="mr-3">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-6"
              />
              {{ $t('activities.processing_type.direct_marketing') }}
             </span>
            <span v-if="processingTypes.automated_decision === 1"  class="mr-3">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-6"
              />
              {{ $t('activities.processing_type.automated_decision') }}
             </span>
            <span v-if="processingTypes.children === 1"  class="mr-3">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-6"
              />
              {{ $t('activities.processing_type.children') }}
             </span>
            <span v-if="processingTypes.monitoring === 1"  class="mr-3">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-6"
              />
              {{ $t('activities.processing_type.monitoring') }}
             </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-2 pr-0">{{ $t('system.validations') }}:</div>
          <div class="col-md-10 pl-0">

            <span v-if="validations.legal_basis === 0 || validations.legal_basis === 1 || validations.legal_basis === 'not_available'" class="mr-3">
              <span v-if="validations.legal_basis === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.legal_basis === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.legal_basis === 'not_available'" >
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.legal_basis') }}
            </span>

            <span v-if="validations.information_obligation === 0 || validations.information_obligation === 1 || validations.information_obligation === 'not_available'" class="mr-3">
              <span v-if="validations.information_obligation === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.information_obligation === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.information_obligation === 'not_available'" >
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.information_obligation') }}
            </span>

            <span v-if="validations.mapping_description === 0 || validations.mapping_description === 1 || validations.mapping_description === 'not_available'" class="mr-3">
              <span v-if="validations.mapping_description === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.mapping_description === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.mapping_description === 'not_available'" >
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.data_flow') }}
            </span>

            <span v-if="validations.retention_rule === 0 || validations.retention_rule === 1 || validations.retention_rule === 'not_available'" class="mr-3">
              <span v-if="validations.retention_rule === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.retention_rule === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.retention_rule === 'not_available'" >
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.retention_rule') }}
            </span>

            <span v-if="validations.integrity_check === 0 || validations.integrity_check === 1 || validations.integrity_check === 'not_available'" class="mr-3">
              <span v-if="validations.integrity_check === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.integrity_check === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.integrity_check === 'not_available'" >
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.integrity_check') }}
            </span>

            <span v-if="validations.processing_type === 0 || validations.processing_type === 1 || validations.processing_type === 'not_available'" class="mr-3">
              <span v-if="validations.processing_type === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.processing_type === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.processing_type === 'not_available'">
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.processing_type') }}
            </span>

            <span v-if="validations.systems === 0 || validations.systems === 1 || validations.systems === 'not_available'" class="mr-3">
              <span v-if="validations.systems === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.systems === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.systems === 'not_available'">
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.system_controls') }}
            </span>

            <span v-if="validations.third_parties === 0 || validations.third_parties === 1 || validations.third_parties === 'not_available'" class="mr-3">
              <span v-if="validations.third_parties === 1" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="validations.third_parties === 0" >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="validations.third_parties === 'not_available'">
                <font-awesome-icon icon="circle" class="icon-warning"/>
              </span>
              {{ $t('validations.checklist.third_parties') }}
            </span>


          </div>
        </div>
      </div>
    </div>

    <!-- Risk scenarios table -->
    <div class="card risk_scenario pagination-margin"
         qid="risk-scenarios-section"
         id="update_risk_scenarios"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="risk-scenarios-table-title" v-if="!showOnTask">
                {{ $t('activities.risk_scenario.label') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_risk_scenarios')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_risk_scenarios')"
                      @reloadContent="loadTasks"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_risk_scenarios')">
                  <GuideButton :guide="getGuide('update_risk_scenarios')"></GuideButton>
                </span>
              </span>
            </div>

            <div class="validation-info" qid="view-rr-validation" v-if="validation && !showOnTask">
              <span v-if="validation && validation.validation === 1">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
              <span v-if="validation && validation.validation === 0">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="validation.created_by" qid="view-rr-validation-by">
                  {{ validation.created_by.name }}
                </span>
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="validation.created_at" qid="view-rr-validation-date">
                  {{ validation.created_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <ValidationForm
                :object="process"
                type="risk_scenario"
                scope="validate_risk_scenarios"
                v-if="!showOnTask && isGranted([permissions.PROCESS_RISK_SCENARIO_VALIDATE, permissions.PROCESS_RISK_SCENARIO_VALIDATE_OWN], process)"
                :disabledItems="disabledValidationOptions"
                @validationModalClose="handleValidationModalClose"
            ></ValidationForm>
            <RiskScenarioCreateForm></RiskScenarioCreateForm>
            <span class="btn btn-success"
                  @click="showCreateRRModal()"
                  v-if="isGranted([permissions.PROCESS_RISK_SCENARIO_CREATE, permissions.PROCESS_RISK_SCENARIO_CREATE_OWN], process)"
                  qid="risk-scenario-create-button"
            >
              <font-awesome-icon icon="plus"/> {{ $t('activities.risk_scenario.add_new') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
            <tr>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('name')"
                  qid="sort-tp-name"
              >
                {{ $t('activities.risk_scenario.table.name') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                </span>
              </th>
              <th scope="col">
                {{ $t('activities.risk_scenario.table.business_risk') }}
              </th>
              <th scope="col">
                {{ $t('activities.risk_scenario.table.privacy_risk') }}
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('updated_at')"
                  qid="sort-p-name"
              >
                {{ $t('system.last_updated') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
                </span>
              </th>
              <th width="240"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="object in rrTableItems">
              <td>
                <span v-if="object.risk_scenario && object.risk_scenario.name"
                      @click="showViewRiskScenarioModal(object)"
                      qid="threat-name-link"
                      class="btn btn-link text-left cursor-pointer"
                >
                  {{ object.risk_scenario.name }}
                </span>
              </td>
              <td>
                <span v-if="object.residual_business_risk && object.residual_business_risk.tolerance" class="text-normal">
                  <span class="badge-pill badge-success mr-1" v-if="object.residual_business_risk.tolerance == 'Below tolerance'">
                    <font-awesome-icon icon="check" size="xs"/>
                  </span>
                  <span class="badge-pill badge-danger mr-1" v-if="object.residual_business_risk.tolerance == 'Above tolerance'">
                    <font-awesome-icon icon="times" size="xs"/>
                  </span>
                  <span class="mr-1" v-if="object.residual_business_risk.tolerance == 'no risk'">
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          :class="'risk-9'"
                      />
                  </span>
                  {{ $t('risk.' + $options.filters.slugify(object.residual_business_risk.tolerance)) }}
                </span>
                <span v-if="!object.residual_business_risk && object.business_tolerance" class="text-normal">
                  <span class="badge-pill badge-success mr-1" v-if="object.business_tolerance == 'Below tolerance'">
                    <font-awesome-icon icon="check" size="xs"/>
                  </span>
                  <span class="badge-pill badge-danger mr-1" v-if="object.business_tolerance == 'Above tolerance'">
                    <font-awesome-icon icon="times" size="xs"/>
                  </span>
                  <span class="mr-1" v-if="object.business_tolerance == 'no risk'">
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          :class="'risk-9'"
                      />
                  </span>
                  {{ $t('risk.' + $options.filters.slugify(object.business_tolerance)) }}
                </span>
                <span v-if="!object.residual_business_risk && !object.business_tolerance" class="text-normal">
                  <span>
                    <font-awesome-icon
                        icon="exclamation-triangle"
                        :class="'risk-9'"
                    />
                  </span>
                  {{ $t('risk.no_risk') }}
                </span>
              </td>
              <td>
                <span v-if="object.residual_privacy_risk && object.residual_privacy_risk.tolerance" class="text-normal">
                  <span class="badge-pill badge-success mr-1" v-if="object.residual_privacy_risk.tolerance == 'Below tolerance'">
                    <font-awesome-icon icon="check" size="xs"/>
                  </span>
                  <span class="badge-pill badge-danger mr-1" v-if="object.residual_privacy_risk.tolerance == 'Above tolerance'">
                    <font-awesome-icon icon="times" size="xs"/>
                  </span>
                  <span class="mr-1" v-if="object.residual_privacy_risk.tolerance == 'no risk'">
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          :class="'risk-9'"
                      />
                  </span>
                  {{ $t('risk.' + $options.filters.slugify(object.residual_privacy_risk.tolerance)) }}
                </span>
                <span v-if="!object.residual_privacy_risk && object.privacy_tolerance" class="text-normal">
                  <span class="badge-pill badge-success mr-1" v-if="object.privacy_tolerance == 'Below tolerance'">
                    <font-awesome-icon icon="check" size="xs"/>
                  </span>
                  <span class="badge-pill badge-danger mr-1" v-if="object.privacy_tolerance == 'Above tolerance'">
                    <font-awesome-icon icon="times" size="xs"/>
                  </span>
                  <span class="mr-1" v-if="object.privacy_tolerance == 'no risk'">
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          :class="'risk-9'"
                      />
                  </span>
                  {{ $t('risk.' + $options.filters.slugify(object.privacy_tolerance)) }}
                </span>
                <span v-if="!object.residual_privacy_risk && !object.privacy_tolerance" class="text-normal">
                  <span>
                    <font-awesome-icon
                        icon="exclamation-triangle"
                        :class="'risk-9'"
                    />
                  </span>
                  {{ $t('risk.no_risk') }}
                </span>

              </td>
              <td>
                <span class="text-normal">
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td class="text-right">
                <span class="btn btn-edit"
                      qid="view-links-button"
                      @click="showInherentRiskModal(object)"
                >
                  {{ $t('activities.risk_scenario.inherent_risk_button') }}
                </span>
                <span v-if="object.risk_scenario && object.risk_scenario.name"
                      @click="showViewRiskScenarioModal(object)"
                      qid="threat-name-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-delete"
                      qid="delete-rr-modal"
                      @click="showRRConfirmDeleteModal(object)"
                      v-if="isGranted([permissions.PROCESS_RISK_SCENARIO_DELETE, permissions.PROCESS_RISK_SCENARIO_DELETE_OWN], process)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!rrLoading && !rrTableItems.length" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div class="text-center mb-4" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="acValidationShow = !acValidationShow"
                qid="expand-rr-validations"
          >
            <span class="mr-2">
              {{ $t('system.view_validation_log') }}
            </span>
            <font-awesome-icon icon="chevron-down" v-if="!acValidationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="acValidationShow"/>
          </span>
        </div>
        <hr class="mb-0" v-show="acValidationShow && !showOnTask">
        <div v-show="acValidationShow && !showOnTask">
          <ValidationList
              :object="process"
              type="risk_scenario"
              :reloadList="updateValidationList"
              @validationListUpdated="setValidation"
          ></ValidationList>
        </div>
      </div>

      <div class="card-body">
        <div class="mt-3 pl-2 pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    label="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="per-page-options"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>

    </div>


    <!-- Delete retention rule modal template -->
    <b-modal ref="delete-rr" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-rr-title">
          {{ $t('activities.risk_scenario.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.risk_scenario.delete.description') }}
        <span v-if="itemToDelete.risk_scenario">{{ itemToDelete.risk_scenario.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.risk_scenario.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideRRConfirmDeleteModal"
                  qid="delete-rr-cancel-button"
        >
          {{ $t('activities.risk_scenario.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteRR(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-rr-submit-button"
        >
          {{ $t('activities.risk_scenario.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Add risk scenario -->
    <b-modal ref="add-risk-scenario" hide-footer @hide="hideCreateRRModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('activities.risk_scenario.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="acFormSubmit" qid="create-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('risk_scenarios.create.risk_category_label') }}
            </label>
            <multiselect
                v-model="riskCategory"
                :options="riskCategories"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('risk_scenarios.create.risk_category_placeholder')"
                label="name"
                track-by="id"
                @search-change="loadRiskCategories"
                qid="create-p-form-pg"
                @select="loadRiskScenariosByCategory"
                @remove="loadRiskScenariosWithoutCategory"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-ac-pg-label">
              {{ $t('activities.risk_scenario.create.risk_scenario_label') }}
            </label>
            <multiselect
                v-model="selectedRR"
                :options="rrItems"
                :placeholder="$t('activities.risk_scenario.create.risk_scenario_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadRiskScenariosItems"
                track-by="id"
                qid="create-rr-form-rr"
            ></multiselect>
          </b-form-group>
          <div v-if="selectedRR && selectedRR.description"
               class="text-center mb-3 mt-4"
          >
            <span class="cursor-pointer">
              <span class="mr-2"
                    @click="showRRDescription = !showRRDescription"
                    qid="expand-rr-description"
              >
                {{$t('activities.risk_scenario.create.description_expand')}}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!showRRDescription"/>
              <font-awesome-icon icon="chevron-up" v-if="showRRDescription"/>
            </span>
          </div>
          <div v-if="selectedRR && selectedRR.description && showRRDescription" class="mb-4 mt-2">
            <span class="text-formatted">
              {{ selectedRR.description }}
            </span>
          </div>
          <div v-if="selectedRR && selectedRR.tags_translated && selectedRR.tags_translated.length">
            <label class="mt-3">
              {{ $t('risk_scenarios.create.tags_label') }}
            </label>
            <br>
            <span class="mr-1" v-for="tag in selectedRR.tags_translated" qid="p-tags-list">
              <span class="badge badge-info mb-1" :title="tag.name_translated">
                {{tag.name_translated | truncate(35)}}
              </span>
            </span>
          </div>
          <br>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateRRModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('activities.risk_scenario.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('activities.risk_scenario.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Inherent risk modal -->
    <b-modal ref="inherent-risk" hide-footer @hide="hideInherentRiskModal" size="xl">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('activities.risk_scenario.inherent_risk.title') }}
        </h4>
      </div>
      <div class="mt-2 mb-2">
        <div v-if="riskScenarioItem && riskScenarioItem.risk_scenario">
          <font-awesome-icon icon="theater-masks" size="lg" /> {{ riskScenarioItem.risk_scenario.name }}
        </div>
        <div v-if="riskScenarioItem && riskScenarioItem.process" class="mt-3">
          <font-awesome-icon icon="cube" size="lg" /> {{ riskScenarioItem.process.name }}
        </div>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <div class="row" v-if="riskScenarioItem.risk_scenario">
        <div :class="{'col-sm-6': riskScenarioItem.risk_scenario.risk_types && riskScenarioItem.risk_scenario.risk_types.length > 1, 'col-sm-12': riskScenarioItem.risk_scenario.risk_types && riskScenarioItem.risk_scenario.risk_types.length <= 1}"
             v-if="hasType('business_risk')"
        >

          <!-- Business risk card -->
          <div class="card" qid="risk-section">
            <div class="card-header">
              <span class="float-right btn btn-success btn-sm mt-4 cursor-pointer"
                    @click="showBusinessFormFunction"
                    v-if="isGranted([permissions.PROCESS_RISK_SCENARIO_EDIT, permissions.PROCESS_RISK_SCENARIO_EDIT_OWN], process)"
                    qid="risk-edit-button"
              >
                {{ $t('system.edit') }}
              </span>
              <h5 class="mt-3 mb-2" qid="risk-table-title">
                {{ $t('activities.risk_scenario.inherent_risk.business_risk') }}
              </h5>
            </div>

            <!-- Single risk -->

            <div class="row no-gutters" v-if="getClient.risk_type != 'cia_risk'">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span class="mt-2">{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showBusinessRiskForm">
                    <multiselect
                        v-model="selectedBusinessInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_impact')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedBusinessInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-2-5"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_probability')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <div v-if="!showBusinessRiskForm">
                    <div v-if="riskScenarioItem && riskScenarioItem.business_inherent_risk">
                      <span :qid="'risk-risk-' + riskScenarioItem.business_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.business_inherent_risk.number"
                          :class="[ riskScenarioItem.business_inherent_risk.number ? 'risk-'+riskScenarioItem.business_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.business_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.business_inherent_risk.number">
                          ({{riskScenarioItem.business_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- CIA risk -->

            <div class="row no-gutters" v-if="getClient.risk_type == 'cia_risk'">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span class="mt-2">{{ $t('processes.confidentiality.title') }}</span>
                </div>
                <div class="card-body text-dark"
                     :class="{
                        'pt-5': showBusinessRiskForm,
                        'mt-5': riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id && showBusinessRiskForm,
                        'mt-3': riskScenarioItem.risk_scenario && !riskScenarioItem.risk_scenario.risk_category && showBusinessRiskForm
                      }"
                >
                  <span class="mt-2">{{ $t('processes.integrity.title') }}</span>
                </div>
                <div class="card-body text-dark"
                    :class="{
                       'pt-5': showBusinessRiskForm,
                       'mt-5': riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id && showBusinessRiskForm,
                       'mt-3': riskScenarioItem.risk_scenario && !riskScenarioItem.risk_scenario.risk_category && showBusinessRiskForm
                     }"
                >
                  <span class="mt-2">{{ $t('processes.availability.title') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body pt-0">

                  <!-- Confidentiality -->
                  <div class="mw-500 mt-2" v-if="showBusinessRiskForm">
                    <multiselect
                        v-model="selectedConfidentialityBusinessInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_confidentiality_impact')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedConfidentialityBusinessInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-1"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_confidentiality_probability')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <!-- Integrity -->
                  <div class="mw-500 mt-4" v-if="showBusinessRiskForm">
                    <multiselect
                        v-model="selectedIntegrityBusinessInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_integrity_impact')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedIntegrityBusinessInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-1"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_integrity_probability')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <!-- Availability -->
                  <div class="mw-500 mt-4" v-if="showBusinessRiskForm">
                    <multiselect
                        v-model="selectedAvailabilityBusinessInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_availability_impact')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedAvailabilityBusinessInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-1"
                    ></multiselect>
                    <div class="text-right" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                      <a @click="openViewDefinitionsModal('business_availability_probability')">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <div v-if="!showBusinessRiskForm">

                    <!-- Confidentiality -->
                    <div v-if="riskScenarioItem && riskScenarioItem.business_confidentiality_inherent_risk" class="card-body pr-0 pl-0">
                      <span :qid="'risk-risk-' + riskScenarioItem.business_confidentiality_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.business_confidentiality_inherent_risk.number"
                          :class="[ riskScenarioItem.business_confidentiality_inherent_risk.number ? 'risk-'+riskScenarioItem.business_confidentiality_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.business_confidentiality_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_confidentiality_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.business_confidentiality_inherent_risk.number">
                          ({{riskScenarioItem.business_confidentiality_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>

                    <!-- Integrity -->
                    <div v-if="riskScenarioItem && riskScenarioItem.business_integrity_inherent_risk" class="card-body pr-0 pl-0">
                      <span :qid="'risk-risk-' + riskScenarioItem.business_integrity_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.business_integrity_inherent_risk.number"
                          :class="[ riskScenarioItem.business_integrity_inherent_risk.number ? 'risk-'+riskScenarioItem.business_integrity_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.business_integrity_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_integrity_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.business_integrity_inherent_risk.number">
                          ({{riskScenarioItem.business_integrity_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>

                    <!-- Availability -->
                    <div v-if="riskScenarioItem && riskScenarioItem.business_availability_inherent_risk" class="card-body pr-0 pl-0">
                      <span :qid="'risk-risk-' + riskScenarioItem.business_availability_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.business_availability_inherent_risk.number"
                          :class="[ riskScenarioItem.business_availability_inherent_risk.number ? 'risk-'+riskScenarioItem.business_availability_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.business_availability_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_availability_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.business_availability_inherent_risk.number">
                          ({{riskScenarioItem.business_availability_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row no-gutters">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.description_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showBusinessRiskForm">
                    <b-form-textarea
                      qid="inherent-risk-form-description"
                      v-model="businessRiskForm.business_description"
                      rows="4"
                      max-rows="4"
                      :placeholder="$t('activities.risk_scenario.inherent_risk.description_placeholder')"
                    ></b-form-textarea>
                  </div>
                  <div v-if="!showBusinessRiskForm">
                    <div v-if="riskScenarioItem.business_description">
                      <p class="text-formatted"
                         qid="inherent-risk-description"
                      >
                        {{riskScenarioItem.business_description}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.financial_impact_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showBusinessRiskForm">
                    <div class="row">
                      <div class="col-sm-5">
                        <b-form-input
                          qid="business-risk-amount"
                          type="number"
                          :placeholder="$t('activities.risk_scenario.inherent_risk.amount_placeholder')"
                          v-model="businessRiskForm.business_amount"
                        ></b-form-input>
                      </div>
                      <div class="col-sm-7">
                        <multiselect
                            v-model="businessRiskForm.business_currency"
                            :options="currencies"
                            :placeholder="$t('activities.risk_scenario.inherent_risk.currency_placeholder')"
                            label="text"
                            :select-label="$t('system.dropdown_select_label')"
                            :selected-label="$t('system.dropdown_selected_label')"
                            :deselect-label="$t('system.dropdown_deselect_label')"
                            qid="create-p-form-pg"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div v-if="!showBusinessRiskForm">
                    <div v-if="riskScenarioItem && riskScenarioItem.business_amount">
                      <p qid="risk-dpia">
                        {{ getBusinessAmount }} {{ riskScenarioItem.business_currency }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.impact_effects_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showBusinessRiskForm">
                    <multiselect
                        v-model="selectedBusinessEffects"
                        :options="riskEffects"
                        :multiple="true"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        :taggable="true"
                        track-by="name"
                        :placeholder="$t('activities.risk_scenario.inherent_risk.impact_effects_label')"
                        label="name"
                        qid="create-do-tags-select"
                        @search-change="loadEffects"
                        @tag="addBusinessTag"
                    ></multiselect>
                    <div class="text-right mt-3">
                      <b-button class="mt-3"
                                variant="secondary"
                                @click="cancelBusinessForm"
                                qid="risk-form-cancel-button"
                      >
                        {{ $t('processes.legal_basis.create.cancel') }}
                      </b-button>
                      <b-button class="mt-3 ml-3"
                                variant="success"
                                @click="businessRiskFormSubmit"
                                qid="risk-form-submit-button"
                      >
                        {{ $t('processes.legal_basis.create.submit') }}
                      </b-button>
                    </div>
                  </div>
                  <div v-if="!showBusinessRiskForm">
                    <div v-if="riskScenarioItem && riskScenarioItem.business_impact_effects">
                      <span class="mr-1" v-for="effect in riskScenarioItem.business_impact_effects" qid="p-tags-list">
                        <span class="badge badge-info mb-1" :title="effect.name">
                          {{ effect.name | truncate(35) }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        <div :class="{'col-sm-6': riskScenarioItem.risk_scenario.risk_types && riskScenarioItem.risk_scenario.risk_types.length > 1, 'col-sm-12': riskScenarioItem.risk_scenario.risk_types && riskScenarioItem.risk_scenario.risk_types.length <= 1}"
             v-if="hasType('privacy_risk')"
        >
          <!-- Privacy risk card -->
          <div class="card" qid="current-risk-section">
            <div class="card-header">
              <span class="float-right btn btn-success btn-sm mt-4 cursor-pointer"
                    @click="showPrivacyFormFunction"
                    v-if="isGranted([permissions.PROCESS_RISK_SCENARIO_EDIT, permissions.PROCESS_RISK_SCENARIO_EDIT_OWN], process)"
                    qid="risk-edit-button"
              >
                {{ $t('system.edit') }}
              </span>
              <h5 class="mt-3 mb-2" qid="risk-table-title">
                {{ $t('activities.risk_scenario.inherent_risk.privacy_risk') }}
              </h5>
            </div>

            <!-- Single risk -->
            <div class="row no-gutters" v-if="getClient.risk_type != 'cia_risk'">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showPrivacyRiskForm">
                    <multiselect
                        v-model="selectedPrivacyInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_impact')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedPrivacyInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-2-5"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_probability')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>
                  <div v-if="!showPrivacyRiskForm">
                    <div v-if="riskScenarioItem && riskScenarioItem.privacy_inherent_risk">
                      <span :qid="'risk-risk-' + riskScenarioItem.privacy_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.privacy_inherent_risk.number"
                          :class="[ riskScenarioItem.privacy_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.privacy_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.privacy_inherent_risk.number">
                          ({{riskScenarioItem.privacy_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CIA risk -->

            <div class="row no-gutters" v-if="getClient.risk_type == 'cia_risk'">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span class="mt-2">{{ $t('processes.confidentiality.title') }}</span>
                </div>
                <div class="card-body text-dark"
                     :class="{
                        'pt-5': showPrivacyRiskForm,
                        'mt-5': riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id && showPrivacyRiskForm,
                        'mt-3': riskScenarioItem.risk_scenario && !riskScenarioItem.risk_scenario.risk_category && showPrivacyRiskForm
                      }"
                >
                  <span class="mt-2">{{ $t('processes.integrity.title') }}</span>
                </div>
                <div class="card-body text-dark"
                    :class="{
                       'pt-5': showPrivacyRiskForm,
                       'mt-5': riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id && showPrivacyRiskForm,
                       'mt-3': riskScenarioItem.risk_scenario && !riskScenarioItem.risk_scenario.risk_category && showPrivacyRiskForm
                     }"
                >
                  <span class="mt-2">{{ $t('processes.availability.title') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body pt-0">

                  <!-- Confidentiality -->
                  <div class="mw-500 mt-2" v-if="showPrivacyRiskForm">
                    <multiselect
                        v-model="selectedConfidentialityPrivacyInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_confidentiality_impact')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedConfidentialityPrivacyInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-1"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_confidentiality_probability')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <!-- Integrity -->
                  <div class="mw-500 mt-4" v-if="showPrivacyRiskForm">
                    <multiselect
                        v-model="selectedIntegrityPrivacyInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_integrity_impact')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedIntegrityPrivacyInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-1"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_integrity_probability')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <!-- Availability -->
                  <div class="mw-500 mt-4" v-if="showPrivacyRiskForm">
                    <multiselect
                        v-model="selectedAvailabilityPrivacyInherentImpact"
                        :options="impactItems"
                        :placeholder="$t('processes.risk.impact_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-impact"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_availability_impact')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                    <multiselect
                        v-model="selectedAvailabilityPrivacyInherentProbability"
                        :options="probabilityItems"
                        :placeholder="$t('processes.risk.probability_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="confidentiality-form-probability"
                        class="mt-1"
                    ></multiselect>
                    <div class="text-right">
                      <a @click="openViewDefinitionsModal('privacy_availability_probability')" v-if="riskScenarioItem.risk_scenario && riskScenarioItem.risk_scenario.risk_category && riskScenarioItem.risk_scenario.risk_category.id">
                        {{ $t('risk_scenarios.view_definitions_button') }}
                      </a>
                    </div>
                  </div>

                  <div v-if="!showPrivacyRiskForm">

                    <!-- Confidentiality -->
                    <div v-if="riskScenarioItem && riskScenarioItem.privacy_confidentiality_inherent_risk" class="card-body pr-0 pl-0">
                      <span :qid="'risk-risk-' + riskScenarioItem.privacy_confidentiality_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.number"
                          :class="[ riskScenarioItem.privacy_confidentiality_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_confidentiality_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_confidentiality_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.number">
                          ({{riskScenarioItem.privacy_confidentiality_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>

                    <!-- Integrity -->
                    <div v-if="riskScenarioItem && riskScenarioItem.privacy_integrity_inherent_risk" class="card-body pr-0 pl-0">
                      <span :qid="'risk-risk-' + riskScenarioItem.privacy_integrity_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.privacy_integrity_inherent_risk.number"
                          :class="[ riskScenarioItem.privacy_integrity_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_integrity_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.privacy_integrity_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_integrity_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.privacy_integrity_inherent_risk.number">
                          ({{riskScenarioItem.privacy_integrity_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>

                    <!-- Availability -->
                    <div v-if="riskScenarioItem && riskScenarioItem.privacy_availability_inherent_risk" class="card-body pr-0 pl-0">
                      <span :qid="'risk-risk-' + riskScenarioItem.privacy_availability_inherent_risk.risk">
                        <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="riskScenarioItem.privacy_availability_inherent_risk.number"
                          :class="[ riskScenarioItem.privacy_availability_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_availability_inherent_risk.number : 'risk' ]"
                        />
                        <span v-if="riskScenarioItem.privacy_availability_inherent_risk.risk">
                          {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_availability_inherent_risk.risk)) }}
                        </span>
                        <span v-if="riskScenarioItem.privacy_availability_inherent_risk.number">
                          ({{riskScenarioItem.privacy_availability_inherent_risk.number}})
                        </span>
                        &nbsp;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row no-gutters">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.description_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showPrivacyRiskForm">
                    <b-form-textarea
                      qid="inherent-risk-form-description"
                      v-model="privacyRiskForm.privacy_description"
                      rows="4"
                      max-rows="4"
                      :placeholder="$t('activities.risk_scenario.inherent_risk.description_placeholder')"
                    ></b-form-textarea>
                  </div>
                  <div v-if="!showPrivacyRiskForm">
                    <div v-if="riskScenarioItem.privacy_description">
                      <p class="text-formatted"
                         qid="inherent-risk-description"
                      >
                        {{riskScenarioItem.privacy_description}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.impact_effects_label') }}</span>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="mw-500" v-if="showPrivacyRiskForm">
                    <multiselect
                        v-model="selectedPrivacyEffects"
                        :options="riskEffects"
                        :multiple="true"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        :taggable="true"
                        track-by="name"
                        :placeholder="$t('activities.risk_scenario.inherent_risk.impact_effects_label')"
                        label="name"
                        qid="create-do-tags-select"
                        @search-change="loadEffects"
                        @tag="addPrivacyTag"
                    ></multiselect>
                  </div>
                  <div v-if="!showPrivacyRiskForm">
                    <div v-if="riskScenarioItem && riskScenarioItem.privacy_impact_effects">
                      <span class="mr-1" v-for="effect in riskScenarioItem.privacy_impact_effects" qid="p-tags-list">
                        <span class="badge badge-info mb-1" :title="effect.name">
                          {{ effect.name | truncate(35) }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters" v-if="showPrivacyRiskForm">
              <div class="col-sm-4 card-menu">
              </div>
              <div class="col-sm-8">
                <div class="card-body">
                  <div class="text-right">
                    <b-button class=""
                              variant="secondary"
                              @click="cancelPrivacyForm"
                              qid="risk-form-cancel-button"
                    >
                      {{ $t('processes.legal_basis.create.cancel') }}
                    </b-button>
                    <b-button class="ml-3"
                              variant="success"
                              @click="privacyRiskFormSubmit"
                              qid="risk-form-submit-button"
                    >
                      {{ $t('processes.legal_basis.create.submit') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <b-button class="mt-4 float-right"
                variant="success"
                @click="hideInherentRiskModal"
                qid="cancel-button"
      >
        {{ $t('processes.policies.view.close') }}
      </b-button>

      <button class="btn btn-secondary float-right mt-4 mr-2"
              qid="current-risk-button"
              @click="showCurrentRiskModal()"
              v-if="isGranted([permissions.RISK_SCENARIO_EDIT, permissions.RISK_SCENARIO_EDIT_OWN], riskScenarioItem.risk_scenario) ||
                    isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], process) ||
                    isValidator"
      >
        {{ $t('activities.risk_scenario.show_current_risk_button') }}
      </button>

    </b-modal>


    <!-- View Risk Scenario modal -->
    <b-modal ref="view-risk-scenario" hide-footer @hide="hideViewRiskScenarioModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title">
          {{ $t('risk_scenarios.view_label') }}
        </h4>
        <h4 v-if="selectedRiskScenario && selectedRiskScenario.risk_scenario">
          '{{ selectedRiskScenario.risk_scenario.name }}'
        </h4>
      </div>
      <b-tabs class="mt-3" v-if="selectedRiskScenario && selectedRiskScenario.risk_scenario">
        <b-tab :title="$t('risk_scenarios.tab.basic_info')" active>
          <div class="modal-tabs-scrollable pt-4">
            <label class="mt-3" v-if="selectedRiskScenario.risk_scenario.types && selectedRiskScenario.risk_scenario.types.length">
              {{ $t('table.scope') }}
            </label>
            <br>
            <span class="mr-1" qid="riskScenario-tags-list" v-if="selectedRiskScenario.risk_scenario.types && selectedRiskScenario.risk_scenario.types.length">
              <span class="mr-1" v-for="type in selectedRiskScenario.risk_scenario.types" qid="p-tags-list">
                <span class="badge badge-info mb-1">
                  {{ $t('risk_scenarios.type.' + $options.filters.slugify(type)) }}
                </span>
              </span>
            </span>
            <br>
            <label class="mt-3" v-if="selectedRiskScenario.risk_scenario.tags_translated && selectedRiskScenario.risk_scenario.tags_translated.length">
              {{ $t('table.tags') }}
            </label>
            <br>
            <span class="mr-1" v-for="tag in selectedRiskScenario.risk_scenario.tags_translated" qid="p-tags-list">
              <span class="badge badge-info mb-1" :title="tag.name_translated">
                {{tag.name_translated | truncate(35)}}
              </span>
            </span>
            <br>
            <label class="mt-3" v-if="selectedRiskScenario.risk_scenario.description">
              {{ $t('systems.create.description_label') }}
            </label>
            <br>
            <p class="text-formatted">
              {{ selectedRiskScenario.risk_scenario.description }}
            </p>
            <br>
          </div>
        </b-tab>
        <b-tab :title="$t('risk_scenarios.tab.threats')" @click="loadRiskThreats(1)">
          <div class="modal-tabs-scrollable">
            <div v-for="object in riskThreatsItems" :key="object.id">
              <h5 class="mt-4">
                <span>
                  {{ object.threat.name }}
                </span>
              </h5>
              <hr>
            </div>
            <div class="text-center mt-4" @click="loadRiskThreats()" v-if="showMore && !loading">
              <a>{{ $t('system.show_more') }}</a>
            </div>
            <div class="text-center mt-5" v-if="riskThreatsItems && !riskThreatsItems.length && !loading">
              <a>{{ $t('system.no_results') }}</a>
            </div>
            <div class="text-center" v-if="loading">
              <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2"/>
              {{ $t('system.loading') }}
            </div>
          </div>
        </b-tab>
        <b-tab :title="$t('risk_scenarios.tab.vulnerabilities')" @click="loadRiskVulnerabilities(1)">
          <div class="modal-tabs-scrollable">
            <div v-for="object in riskVulnerabilitiesItems" :key="object.id">
              <h5 class="mt-4">
                <span>
                  {{ object.vulnerability.name }}
                </span>
              </h5>
              <hr>
            </div>
            <div class="text-center mt-4" @click="loadRiskVulnerabilities()" v-if="showMore && !loading">
              <a>{{ $t('system.show_more') }}</a>
            </div>
            <div class="text-center mt-5" v-if="riskVulnerabilitiesItems && !riskVulnerabilitiesItems.length && !loading">
              <a>{{ $t('system.no_results') }}</a>
            </div>
            <div class="text-center" v-if="loading">
              <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2"/>
              {{ $t('system.loading') }}
            </div>
          </div>
        </b-tab>
        <div>
          <b-button class="mt-4 mb-4 float-right"
                    variant="success"
                    @click="hideViewRiskScenarioModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('processes.policies.view.close') }}
          </b-button>
        </div>
      </b-tabs>

    </b-modal>


    <ResidualRiskModal
        :object="riskScenarioItem"
        :show="showResidualModal"
        @closeResidualModal="hideCurrentRiskModal"
    ></ResidualRiskModal>

    <ViewDefinitions
        :showModal="showViewDefinitionsModal"
        :type="definitionType"
        :object="riskScenarioItem.risk_scenario"
        @closeViewModal="handleCloseViewDefinitionsModal"
    ></ViewDefinitions>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import RiskScenarioCreateForm from '@/views/RiskScenarios/RiskScenarioCreateForm.vue';
  import ViewDefinitions from '@/views/RiskScenarios/ViewDefinitionsModal.vue';
  import ResidualRiskModal from '@/views/RiskScenarios/ResidualRiskModal.vue';
  import roleCheck from '@/util/ACL/roleCheck.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'RiskScenariosTable',
    data: function() {
      return {
        acForm: {
          name: ''
        },
        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        keywordValue: '',
        selectedSort: '',
        selectedDirection: '',

        businessRiskForm: {
          business_inherent_risk_impact: '',
          business_inherent_risk_probability: '',
          business_confidentiality_risk_impact: '',
          business_confidentiality_risk_probability: '',
          business_integrity_risk_impact: '',
          business_integrity_risk_probability: '',
          business_availability_risk_impact: '',
          business_availability_risk_probability: '',
          business_impact_effects: [],
          business_description: '',
          business_amount: '',
          business_currency: []
        },
        businessRisks: [],
        privacyRiskForm: {
          privacy_included: '',
          privacy_inherent_risk_impact: '',
          privacy_inherent_risk_probability: '',
          privacy_confidentiality_risk_impact: '',
          privacy_confidentiality_risk_probability: '',
          privacy_integrity_risk_impact: '',
          privacy_integrity_risk_probability: '',
          privacy_availability_risk_impact: '',
          privacy_availability_risk_probability: '',
          privacy_impact_effects: [],
          privacy_description: ''
        },
        privacyRisks: [],
        error: '',
        loading: true,
        showMore: true,
        newBusinessError: '',
        newPrivacyError: '',
        loadingItems: false,
        selectedRR: [],
        viewRRModal: false,
        editRRModal: false,
        selectedRRSort: '',
        selectedRRDirection: '',
        acValidationShow: false,
        rrTableItems: [],
        rrLoading: true,
        rrItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: undefined,
        disabledValidationOptions: [],
        showRRDescription: false,
        buttonDisabled: false,
        riskScenarioItem: {},
        showBusinessRiskForm: false,
        showPrivacyRiskForm: false,
        currencies: [
          {text: 'DKK', value: 'DKK'},
          {text: 'EUR', value: 'EUR'},
          {text: 'GBP', value: 'GBP'},
          {text: 'USD', value: 'USD'}
        ],
        impactItems: [
          { name: this.$t('impact.very_low'), value: 'Very low' },
          { name: this.$t('impact.low'), value: 'Low' },
          { name: this.$t('impact.high'), value: 'High' },
          { name: this.$t('impact.very_high'), value: 'Very high' }
        ],
        probabilityItems: [
          { name: this.$t('probability.very_unlikely'), value: 'Very unlikely' },
          { name: this.$t('probability.unlikely'), value: 'Unlikely' },
          { name: this.$t('probability.likely'), value: 'Likely' },
          { name: this.$t('probability.very_likely'), value: 'Very likely' }
        ],
        privacyIncludedOptions: [
          { name: this.$t('system.no'), value: 0 },
          { name: this.$t('system.yes'), value: 1 }
        ],
        loadingBusinessRisks: true,
        loadingPrivacyRisks: true,
        riskEffects: [],
        selectedBusinessEffects: [],
        selectedPrivacyEffects: [],
        newTags: [],

        selectedPrivacyInherentImpact: [],
        selectedPrivacyInherentProbability: [],

        selectedBusinessInherentImpact: [],
        selectedBusinessInherentProbability: [],

        selectedConfidentialityPrivacyInherentImpact: [],
        selectedConfidentialityPrivacyInherentProbability: [],
        selectedIntegrityPrivacyInherentImpact: [],
        selectedIntegrityPrivacyInherentProbability: [],
        selectedAvailabilityPrivacyInherentImpact: [],
        selectedAvailabilityPrivacyInherentProbability: [],

        selectedConfidentialityBusinessInherentImpact: [],
        selectedConfidentialityBusinessInherentProbability: [],
        selectedIntegrityBusinessInherentImpact: [],
        selectedIntegrityBusinessInherentProbability: [],
        selectedAvailabilityBusinessInherentImpact: [],
        selectedAvailabilityBusinessInherentProbability: [],

        riskToDelete: {},
        selectedRiskScenario: {},
        riskThreatsItems: [],
        riskVulnerabilitiesItems: [],
        selectedRisk: {},
        dataTypes: [],
        validations: [],
        processingTypes: [],
        mitigationFactorsShow: false,
        showViewDefinitionsModal: false,
        definitionType: '',
        showResidualModal: false,
        isValidator: roleCheck('Validator'),
        myGuides: [],
        myTasks: [],
        riskCategory: [],
        riskCategories: [],
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      RiskScenarioCreateForm,
      ViewDefinitions,
      ResidualRiskModal,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getBusinessAmount() {
        let transformed = ''
        if (this.riskScenarioItem && this.riskScenarioItem.business_amount) {
          transformed = this.riskScenarioItem.business_amount.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        }
        return transformed
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if (selectedTo > selectedOf) {
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadRiskScenariosItems();
      },
      object: function (value) {
        if (value && value.id) {
          this.process = value
          this.loadTasks('update_risk_scenarios');
          this.loadRiskScenarios();
          this.loadProcessingTypes();
          this.loadDataTypes();
          this.loadValidations();
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.process.id && this.$store.state.updatedObject.who_am_i == this.process.who_am_i) {
              this.process = this.$store.state.updatedObject
            }
          }
          this.loadRiskScenarios();
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_risk_scenarios')
        }
      },
    },
    methods: {
      setValidation(object) {
        this.validation = object
        this.updateValidationList = false;
      },
      getHighestRisk(myArray) {
        var lowest = Number.POSITIVE_INFINITY;
        var highest = Number.NEGATIVE_INFINITY;

        var tmp;
        let highestObject = {}

        for (var i = myArray.length - 1; i >= 0; i--) {
            tmp = myArray[i].number;
            if (tmp < lowest) lowest = tmp;
            if (tmp > highest) {
              highestObject = myArray[i]
              highest = tmp;
            }
        }
        return highestObject
      },
      hasType(type, object) {
        let self = this;
        let found = false
        if (object) {
          if (object.risk_types && object.risk_types.length) {
            _.find(object.risk_types, function(item) {
              if (item == type) {
                found = true;
              }
            });
          }
        } else {
          if (this.riskScenarioItem && this.riskScenarioItem.risk_scenario) {
            if (this.riskScenarioItem.risk_scenario.risk_types && this.riskScenarioItem.risk_scenario.risk_types.length) {
              _.find(this.riskScenarioItem.risk_scenario.risk_types, function(item) {
                if (item == type) {
                  found = true;
                }
              });
            }
          }
        }
        return found
      },
      showCurrentRiskModal(object) {
        this.riskScenarioItem.risk_category = this.riskScenarioItem.risk_scenario.risk_category
        this.showResidualModal = true;
      },
      hideCurrentRiskModal() {
        this.showResidualModal = false;
        this.error = ''
      },
      pageChanged(page) {
        this.loadRiskScenarios(page)
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        // Load content when page changed listener is triggered
        this.loadRiskScenarios(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadRiskScenarios(1, self.selectedPerPage)
      },
      openViewDefinitionsModal(type) {
        this.definitionType = type
        this.showViewDefinitionsModal = true
      },
      handleCloseViewDefinitionsModal () {
        this.definitionType = ''
        this.showViewDefinitionsModal = false;
      },
      addBusinessTag(newTag) {
        const tag = {
          name: newTag,
          value: newTag
        }
        this.selectedBusinessEffects.push(tag)
        this.newTags.push(tag)
      },
      addPrivacyTag(newTag) {
        const tag = {
          name: newTag,
          value: newTag
        }
        this.selectedPrivacyEffects.push(tag)
        this.newTags.push(tag)
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.process.who_am_i,
              model_id: this.process.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Process' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Process',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showBusinessFormFunction() {
        let self = this;
        this.newTags = []
        this.loadEffects()

        if (this.getClient.risk_type == 'cia_risk') {

          // Confidentiality
          if (this.riskScenarioItem.business_confidentiality_risk_impact) {
            this.selectedConfidentialityBusinessInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.business_confidentiality_risk_impact;
            });
          } else {
            this.selectedConfidentialityBusinessInherentImpact = []
          }

          if (this.riskScenarioItem.business_confidentiality_risk_probability) {
            this.selectedConfidentialityBusinessInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.business_confidentiality_risk_probability;
            });
          } else {
            this.selectedConfidentialityBusinessInherentProbability = []
          }

          // Integrity
          if (this.riskScenarioItem.business_integrity_risk_impact) {
            this.selectedIntegrityBusinessInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.business_integrity_risk_impact;
            });
          } else {
            this.selectedIntegrityBusinessInherentImpact = []
          }

          if (this.riskScenarioItem.business_integrity_risk_probability) {
            this.selectedIntegrityBusinessInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.business_integrity_risk_probability;
            });
          } else {
            this.selectedIntegrityBusinessInherentProbability = []
          }

          // Availability
          if (this.riskScenarioItem.business_availability_risk_impact) {
            this.selectedAvailabilityBusinessInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.business_availability_risk_impact;
            });
          } else {
            this.selectedAvailabilityBusinessInherentImpact = []
          }

          if (this.riskScenarioItem.business_availability_risk_probability) {
            this.selectedAvailabilityBusinessInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.business_availability_risk_probability;
            });
          } else {
            this.selectedAvailabilityBusinessInherentProbability = []
          }

        } else {

          if (this.riskScenarioItem.business_inherent_risk_impact) {
            this.selectedBusinessInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.business_inherent_risk_impact;
            });
          } else {
            this.selectedBusinessInherentImpact = []
          }

          if (this.riskScenarioItem.business_inherent_risk_probability) {
            this.selectedBusinessInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.business_inherent_risk_probability;
            });
          } else {
            this.selectedBusinessInherentProbability = []
          }

        }

        if (this.riskScenarioItem.business_currency) {
          this.businessRiskForm.business_currency = _.find(this.currencies, function(item) {
            return item.value === self.riskScenarioItem.business_currency;
          });
        } else {
          this.businessRiskForm.business_currency = []
        }

        this.selectedBusinessEffects = []
        if (this.riskScenarioItem.business_impact_effects && this.riskScenarioItem.business_impact_effects.length) {
          this.selectedBusinessEffects = _.cloneDeep(this.riskScenarioItem.business_impact_effects);
        }

        this.businessRiskForm.business_description = this.riskScenarioItem.business_description
        this.businessRiskForm.business_amount = this.riskScenarioItem.business_amount

        this.showBusinessRiskForm = true
      },
      cancelBusinessForm() {
        this.showBusinessRiskForm = false
      },
      showPrivacyFormFunction() {
        let self = this;
        this.newTags = []
        this.loadEffects()

        if (this.getClient.risk_type == 'cia_risk') {

          // Confidentiality
          if (this.riskScenarioItem.privacy_confidentiality_risk_impact) {
            this.selectedConfidentialityPrivacyInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_confidentiality_risk_impact;
            });
          } else {
            this.selectedConfidentialityPrivacyInherentImpact = []
          }

          if (this.riskScenarioItem.privacy_confidentiality_risk_probability) {
            this.selectedConfidentialityPrivacyInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_confidentiality_risk_probability;
            });
          } else {
            this.selectedConfidentialityPrivacyInherentProbability = []
          }

          // Integrity
          if (this.riskScenarioItem.privacy_integrity_risk_impact) {
            this.selectedIntegrityPrivacyInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_integrity_risk_impact;
            });
          } else {
            this.selectedIntegrityPrivacyInherentImpact = []
          }

          if (this.riskScenarioItem.privacy_integrity_risk_probability) {
            this.selectedIntegrityPrivacyInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_integrity_risk_probability;
            });
          } else {
            this.selectedIntegrityPrivacyInherentProbability = []
          }

          // Availability
          if (this.riskScenarioItem.privacy_availability_risk_impact) {
            this.selectedAvailabilityPrivacyInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_availability_risk_impact;
            });
          } else {
            this.selectedAvailabilityPrivacyInherentImpact = []
          }

          if (this.riskScenarioItem.privacy_availability_risk_probability) {
            this.selectedAvailabilityPrivacyInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_availability_risk_probability;
            });
          } else {
            this.selectedAvailabilityPrivacyInherentProbability = []
          }

        } else {
          if (this.riskScenarioItem.privacy_inherent_risk_impact) {
            this.selectedPrivacyInherentImpact = _.find(this.impactItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_inherent_risk_impact;
            });
          } else {
            this.selectedPrivacyInherentImpact = []
          }

          if (this.riskScenarioItem.privacy_inherent_risk_probability) {
            this.selectedPrivacyInherentProbability = _.find(this.probabilityItems, function(item) {
              return item.value === self.riskScenarioItem.privacy_inherent_risk_probability;
            });
          } else {
            this.selectedPrivacyInherentProbability = []
          }
        }

        this.privacyRiskForm.privacy_included = _.find(this.privacyIncludedOptions, function(item) {
          return item.value === self.riskScenarioItem.privacy_included;
        });

        if (this.privacyRiskForm.privacy_included == null) {
          this.privacyRiskForm.privacy_included = this.privacyIncludedOptions[0]
        }

        this.selectedPrivacyEffects = []
        if (this.riskScenarioItem.privacy_impact_effects && this.riskScenarioItem.privacy_impact_effects.length) {
          this.selectedPrivacyEffects = _.cloneDeep(this.riskScenarioItem.privacy_impact_effects);
        }

        this.privacyRiskForm.privacy_description = this.riskScenarioItem.privacy_description

        this.showPrivacyRiskForm = true
      },
      cancelPrivacyForm() {
        this.showPrivacyRiskForm = false
      },
      showViewRiskScenarioModal(object) {
        this.selectedRiskScenario = object;
        this.$refs['view-risk-scenario'].show()
      },
      hideViewRiskScenarioModal() {
        this.selectedRiskScenario = {}
        this.$refs['view-risk-scenario'].hide()
      },
      showCreateRRModal() {
        this.loadRiskScenariosItems();
        this.loadRiskCategories();
        this.$refs['add-risk-scenario'].show()
      },
      hideCreateRRModal() {
        this.error = ''
        this.selectedRR = []
        this.riskCategory = []
        this.loadContent()
        this.$refs['add-risk-scenario'].hide()
      },
      showInherentRiskModal(object) {
        this.riskScenarioItem = object;
        this.$refs['inherent-risk'].show()
      },
      hideInherentRiskModal() {
        this.cancelBusinessForm()
        this.cancelPrivacyForm()
        this.loadRiskScenarios()
        this.riskScenarioItem = {}
        this.error = ''
        this.$refs['inherent-risk'].hide()
      },
      showRRConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-rr'].show()
      },
      showViewRiskModal(object) {
        this.selectedRisk = object;
        this.$refs['view-risk'].show()
      },
      hideViewRiskModal() {
        this.selectedRisk = {}
        this.$refs['view-risk'].hide()
      },
      hideRRConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-rr'].hide()
      },
      showActivityRiskScenarioDeleteModal(object) {
        this.riskToDelete = object
        this.$refs['delete-activity-risk'].show()
      },
      hideActivityRiskScenarioDeleteModal() {
        this.riskToDelete = {}
        this.$refs['delete-activity-risk'].hide()
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      confirmDeleteRR(object) {
        let self = this;
        piincHttp.delete('processes/' + this.process.slug + '/risk-scenarios/' + object.id).then(function() {
          self.hideRRConfirmDeleteModal();
          self.loadRiskScenarios();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('activities.risk_scenario.delete.success'))
        }, function() {});
      },
      acFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedRR && this.selectedRR.id) {
          formData.append("risk_scenario_id", this.selectedRR.id);
        }

        formData.append("process", this.process.slug);

        piincHttp.post('/processes/' + this.process.slug + '/risk-scenarios', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('activities.risk_scenario.create.success'))
          self.hideCreateRRModal();
          self.loadRiskScenarios();
          self.$emit('updated');
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.risk_scenario_id) {
              self.error += ' ' + error.data.errors.risk_scenario_id[0]
            }
          }
        })
      },
      privacyRiskFormSubmit() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        this.privacyRiskForm.privacy_inherent_risk_impact = ''
        this.privacyRiskForm.privacy_inherent_risk_probability = ''

        this.privacyRiskForm.privacy_confidentiality_risk_impact = ''
        this.privacyRiskForm.privacy_confidentiality_risk_probability = ''
        this.privacyRiskForm.privacy_integrity_risk_impact = ''
        this.privacyRiskForm.privacy_integrity_risk_probability = ''
        this.privacyRiskForm.privacy_availability_risk_impact = ''
        this.privacyRiskForm.privacy_availability_risk_probability = ''

        if (this.selectedPrivacyInherentImpact) {
          this.privacyRiskForm.privacy_inherent_risk_impact = this.selectedPrivacyInherentImpact.value;
        }
        if (this.selectedPrivacyInherentProbability) {
          this.privacyRiskForm.privacy_inherent_risk_probability = this.selectedPrivacyInherentProbability.value;
        }

        // Confidentiality
        if (this.selectedConfidentialityPrivacyInherentImpact) {
          this.privacyRiskForm.privacy_confidentiality_risk_impact = this.selectedConfidentialityPrivacyInherentImpact.value;
        }
        if (this.selectedConfidentialityPrivacyInherentProbability) {
          this.privacyRiskForm.privacy_confidentiality_risk_probability = this.selectedConfidentialityPrivacyInherentProbability.value;
        }

        // Integrity
        if (this.selectedIntegrityPrivacyInherentImpact) {
          this.privacyRiskForm.privacy_integrity_risk_impact = this.selectedIntegrityPrivacyInherentImpact.value;
        }
        if (this.selectedIntegrityPrivacyInherentProbability) {
          this.privacyRiskForm.privacy_integrity_risk_probability = this.selectedIntegrityPrivacyInherentProbability.value;
        }

        // Availability
        if (this.selectedAvailabilityPrivacyInherentImpact) {
          this.privacyRiskForm.privacy_availability_risk_impact = this.selectedAvailabilityPrivacyInherentImpact.value;
        }
        if (this.selectedAvailabilityPrivacyInherentProbability) {
          this.privacyRiskForm.privacy_availability_risk_probability = this.selectedAvailabilityPrivacyInherentProbability.value;
        }

        this.privacyRiskForm.privacy_impact_effects = [];
        if (this.selectedPrivacyEffects && this.selectedPrivacyEffects.length) {
          for (var i = 0; i < this.selectedPrivacyEffects.length; i++) {
            this.privacyRiskForm.privacy_impact_effects.push(this.selectedPrivacyEffects[i].name);
          }
        }

        if (this.privacyRiskForm.privacy_included) {
          this.privacyRiskForm.privacy_included = this.privacyRiskForm.privacy_included.value;
        }

        piincHttp.put('processes/' + this.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id, this.privacyRiskForm).then(function(response) {
          self.riskScenarioItem = response.data
          self.cancelPrivacyForm()
          self.$toastr('success', self.$t('activities.risk_scenario.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      businessRiskFormSubmit() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        this.businessRiskForm.business_inherent_risk_impact = ''
        this.businessRiskForm.business_inherent_risk_probability = ''

        this.businessRiskForm.business_confidentiality_risk_impact = ''
        this.businessRiskForm.business_confidentiality_risk_probability = ''
        this.businessRiskForm.business_integrity_risk_impact = ''
        this.businessRiskForm.business_integrity_risk_probability = ''
        this.businessRiskForm.business_availability_risk_impact = ''
        this.businessRiskForm.business_availability_risk_probability = ''

        if (this.selectedBusinessInherentImpact) {
          this.businessRiskForm.business_inherent_risk_impact = this.selectedBusinessInherentImpact.value;
        }
        if (this.selectedBusinessInherentProbability) {
          this.businessRiskForm.business_inherent_risk_probability = this.selectedBusinessInherentProbability.value;
        }

        // Confidentiality
        if (this.selectedConfidentialityBusinessInherentImpact) {
          this.businessRiskForm.business_confidentiality_risk_impact = this.selectedConfidentialityBusinessInherentImpact.value;
        }
        if (this.selectedConfidentialityBusinessInherentProbability) {
          this.businessRiskForm.business_confidentiality_risk_probability = this.selectedConfidentialityBusinessInherentProbability.value;
        }

        // Integrity
        if (this.selectedIntegrityBusinessInherentImpact) {
          this.businessRiskForm.business_integrity_risk_impact = this.selectedIntegrityBusinessInherentImpact.value;
        }
        if (this.selectedIntegrityBusinessInherentProbability) {
          this.businessRiskForm.business_integrity_risk_probability = this.selectedIntegrityBusinessInherentProbability.value;
        }

        // Availability
        if (this.selectedAvailabilityBusinessInherentImpact) {
          this.businessRiskForm.business_availability_risk_impact = this.selectedAvailabilityBusinessInherentImpact.value;
        }
        if (this.selectedAvailabilityBusinessInherentProbability) {
          this.businessRiskForm.business_availability_risk_probability = this.selectedAvailabilityBusinessInherentProbability.value;
        }

        if (this.businessRiskForm.business_currency) {
          this.businessRiskForm.business_currency = this.businessRiskForm.business_currency.value;
        }

        this.businessRiskForm.business_impact_effects = [];
        if (this.selectedBusinessEffects && this.selectedBusinessEffects.length) {
          for (var i = 0; i < this.selectedBusinessEffects.length; i++) {
            this.businessRiskForm.business_impact_effects.push(this.selectedBusinessEffects[i].name);
          }
        }

        piincHttp.put('processes/' + this.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id, this.businessRiskForm).then(function(response) {
          self.riskScenarioItem = response.data
          self.cancelBusinessForm()
          self.$toastr('success', self.$t('activities.risk_scenario.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      loadContent() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug).then(function(response) {
          self.process = response.data;
        }, function() {});
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadRiskScenarios();
      },
      loadRiskScenarios(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;

        piincHttp.get('processes/' + this.process.slug + '/risk-scenarios', { params:
          {
            client: this.getClient.slug,
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined
          }
        }).then(function(response) {
          self.rrTableItems = response.data.items;
          self.totalRows = response.data.total_count;
          self.rrLoading = false;
        }, function() {});
      },
      loadRiskScenariosItems(query) {
        let self = this;
        piincHttp.get('risk-scenarios', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            types: ['process'],
            keyword: query ? query : undefined,
            serialize_group: 'member'
          }
        }).then(function(response) {
          self.rrItems = response.data.items
          if (self.rrItems && !self.rrItems.length && !query) {
            self.rrItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.rrItems && self.rrItems.length) {
            self.validationOptions = _.cloneDeep(self.rrItems[0].validationOptions)
          }
        }, function() {});
      },
      loadRiskScenariosByCategory(category) {
        let self = this;
        piincHttp.get('risk-scenarios', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            types: ['process'],
            category: category.id,
            serialize_group: 'member'
          }
        }).then(function(response) {
          self.rrItems = response.data.items
          if (self.rrItems && !self.rrItems.length && !query) {
            self.rrItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.rrItems && self.rrItems.length) {
            self.validationOptions = _.cloneDeep(self.rrItems[0].validationOptions)
          }
        }, function() {});
      },
      loadRiskScenariosWithoutCategory(category) {
        let self = this;
        piincHttp.get('risk-scenarios', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            types: ['process'],
            serialize_group: 'member'
          }
        }).then(function(response) {
          self.rrItems = response.data.items
          if (self.rrItems && !self.rrItems.length && !query) {
            self.rrItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.rrItems && self.rrItems.length) {
            self.validationOptions = _.cloneDeep(self.rrItems[0].validationOptions)
          }
        }, function() {});
      },
      loadEffects(query) {
        let self = this;
        piincHttp.get('impact-effects', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.riskEffects = response.data.items
          if (self.riskEffects && !self.riskEffects.length && !query) {
            self.riskEffects.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadRiskVulnerabilities(reset) {
        if (reset) {
          this.page = 1
          this.showMore = true;
          this.riskVulnerabilitiesItems = []
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.selectedRiskScenario.risk_scenario.slug + '/vulnerabilities', { params:
          {
            client: this.getClient.slug,
            page: this.page,
            model_type: this.selectedRiskScenario.process.who_am_i,
            model_id: this.selectedRiskScenario.process.id
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 10 || (response.data.items.length == 10 && response.data.total_count == 10 * self.page))) {
            self.showMore = false;
          }

          self.page += 1;
          self.loading = false;
          self.riskVulnerabilitiesItems.push(...response.data.items)

        }, function() {});
      },
      loadRiskThreats(reset) {
        if (reset) {
          this.page = 1
          this.showMore = true;
          this.riskThreatsItems = []
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.selectedRiskScenario.risk_scenario.slug + '/threats', { params:
          {
            client: this.getClient.slug,
            page: this.page,
            model_type: this.selectedRiskScenario.process.who_am_i,
            model_id: this.selectedRiskScenario.process.id
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 10 || (response.data.items.length == 10 && response.data.total_count == 10 * self.page))) {
            self.showMore = false;
          }

          self.page += 1;
          self.loading = false;
          self.riskThreatsItems.push(...response.data.items)

        }, function() {});
      },
      loadDataTypes() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug + '/data-types').then(function(response) {
          self.dataTypes = response.data;
        }, function() {});
      },
      loadValidations() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug + '/validations').then(function(response) {
          self.validations = response.data;
        }, function() {});
      },
      loadProcessingTypes() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug + '/processing-types').then(function(response) {
          self.processingTypes = response.data;
        }, function() {});
      },
      loadRiskCategories(query) {
        let self = this;
        piincHttp.get('risk-categories', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined,
            per_page: 100
          }
        }).then(function(response) {
          self.riskCategories = response.data.items
          if (self.riskCategories && !self.riskCategories.length && !query) {
            self.riskCategories.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      }
    },
    created () {
      this.process = this.object
      if (this.getClient && this.getClient.slug) {
        this.loadRiskScenariosItems();
        this.loadRiskCategories();
      }
      if (this.process && this.process.slug) {
        this.loadTasks('update_risk_scenarios');
        this.loadRiskScenarios();
        this.loadProcessingTypes();
        this.loadDataTypes();
        this.loadValidations();
      }
      this.loadGuides('update_risk_scenarios');
    }
  }
</script>
